import { Search } from 'blaze-ui/icons'
import Styles from './TikTokPreview.module.scss'

export const TopActions = () => {
  return (
    <div className={Styles.topActions}>
      <div className={Styles.categories}>
        <div>Following</div>
        <div>Shop</div>
        <div className={Styles.activeTab}>For You</div>
      </div>
      <div className={Styles.searchIcon}>
        <Search />
      </div>
    </div>
  )
}
